import type { BlockDataRequestDto } from '@reports/application/dtos';
import type { IReportStoragePort } from '@reports/application/ports';

export const saveAppliedFiltersUseCase = (storagePort: IReportStoragePort) => {
  const execute = async (filters: BlockDataRequestDto): Promise<void> => {
    await storagePort.saveAppliedFilters(filters);
  };

  return { execute };
};
